import { useMemo } from 'react';

const useDeobfuscatePostId = (obfuscatedPostId, seed) => {
    return useMemo(() => {
        if (obfuscatedPostId == null || seed == null) return null;
        const postId = parseInt(obfuscatedPostId, 16) ^ seed;
        return postId;
    }, [obfuscatedPostId, seed]);
};

export default useDeobfuscatePostId;